var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 6.265L14.68 5.725C13.6537 3.69581 12.3383 1.82632 10.775 0.175L10.6 0H9.6L9.445 0.21C7.95074 1.89869 6.64161 3.74253 5.54 5.71L6.6 6.28C7.435 4.76056 8.40561 3.3197 9.5 1.975V16.1H10.7V1.91C11.8302 3.24589 12.8032 4.70713 13.6 6.265Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.2H20.2V8.5H12.6V9.7H19V19H1.2V9.7H7.6V8.5H0V20.2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f38332330becf2ca92ea2ffb1c19240e.svg";
export { ForwardRef as ReactComponent };